import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import { useData } from '../../context/DataContext';
import Loading from '../Loading/Loading';
import './RegisteredUsers.css';
import MaterialReactTableWithSearch from '../MaterialTable/MaterialReactTableWithSearch';

function RegisteredUsers() {
    const { userData, loading, error, todayRegistrations } = useData();
    const [activeFilter, setActiveFilter] = useState('total');

    if (loading) return <Loading />;
    if (error) return <div style={{ padding: 24, color: 'red' }}>Error: {error}</div>;
    if (!userData) return <div style={{ padding: 24 }}>No user data available.</div>;

    const columns = [
        { accessorFn: (row, index) => index + 1, header: 'SNO', id: 'id', size: 60 },
        { accessorKey: 'name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        {
            accessorKey: 'phone',
            header: 'Mobile',
            Cell: ({ cell }) => {
                const n = cell.getValue();
                return <span>{n ? n.replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '-'}</span>;
            },
        },
        {
            accessorKey: 'inserted_time',
            header: 'Registered Date',
            Cell: ({ cell }) => {
                const d = new Date(cell.getValue());
                return <span>{d.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '')}</span>;
            },
        },
    ];

    const activeData = activeFilter === 'total' ? userData : todayRegistrations;

    return (
        <Container fluid className="px-0">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Registered Users</h1>
                    <p className="page-subtitle">{userData.length} total users registered</p>
                </div>
            </div>

            <div className="filter-bar">
                <button
                    className={`btn-filter ${activeFilter === 'total' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('total')}
                >
                    All Users
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{userData.length}</span>
                </button>
                <button
                    className={`btn-filter ${activeFilter === 'today' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('today')}
                >
                    Today
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{todayRegistrations.length}</span>
                </button>
            </div>

            <div className="table-container">
                <MaterialReactTableWithSearch columns={columns} data={activeData} />
            </div>
        </Container>
    );
}

export default RegisteredUsers;
